import { apiCache } from '@/utils/request'

export const getTreeChannel = async () => {
  return await apiCache({
    url: 'tree_channel',
    method: 'get',
    data: { status: 'NORMAL' },
    cacheName: 'TreeChannel',
    cacheTime: 1
  })
}

export const getChannelDetail = async (id) => {
  return await apiCache({
    url: `channel/${id}`,
    method: 'get',
    cacheName: `ChannelDetail-${id}`,
    cacheTime: 1
  })
}
